import i18n from '@/plugins/i18n';

const connectionsCSGraphs = () => ({
  areaCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.connections-and-sessions'),
      header: {
        title: i18n.global.t('dbm.connections-and-sessions'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7', '#abc0ff', '#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_active_connections,meter_cassandra_idle_connections,meter_cassandra_sessions,meter_cassandra_repair_session_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.heartbeat'),
      header: {
        title: i18n.global.t('dbm.heartbeat'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#90739f', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cassandra_heartbeat',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
      options: {
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'right',
          offsetY: -10,
          offsetX: -10,
        },
      },
    },
  ],
});

export default connectionsCSGraphs;
